module.exports = __webpack_public_path__ + "img/newsImg11-3.3fcbca77.png";